import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { FigurineWithRating, Category } from '@/lib/types';

export function useFigurines(categoryFilter?: string) {
  const [figurines, setFigurines] = useState<FigurineWithRating[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      let query = supabase.from('figurines_with_rating').select('*');
      if (categoryFilter && categoryFilter !== 'all') {
        query = query.eq('category_slug', categoryFilter);
      }
      const { data, error } = await query.order('created_at', { ascending: false });
      if (error) setError(error.message);
      else setFigurines((data ?? []) as FigurineWithRating[]);
      setLoading(false);
    };
    fetch();
  }, [categoryFilter]);

  return { figurines, loading, error };
}

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    supabase
      .from('categories')
      .select('*')
      .order('sort_order')
      .then(({ data }) => setCategories((data ?? []) as Category[]));
  }, []);

  return { categories };
}
